import React from "react";
import OrderRow from "./OrderRow";

const OrderListTable = ({ orders }) => {
  const totalIraqiPrice = orders.reduce((sum, order) => sum + order.totalIraqiprice, 0);
  const totalCartons = orders.reduce((sum, order) => sum + order.totalCount, 0);

  const formatNumber = (number) => {
    return new Intl.NumberFormat("en-US").format(number);
  };

  return (
    <>
      <div className="container mx-auto border-t pb-8">
        <table className="w-full text-sm text-left text-gray-500">
          <thead className="text-xs text-gray-700 uppercase bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-center"></th>
              <th className="px-6 py-3 text-center"></th>
              <th className="px-6 py-3 text-center"></th>
              <th className="px-6 py-3 text-center">المبلغ الكلي (بالعراقي)</th>
              <th className="px-6 py-3 text-center">عددالكراتين بالطلب</th>
              <th className="px-6 py-3 text-center">حالة الطلب</th>
              <th className="px-6 py-3 text-center">تاريخ الطلب</th>
              <th className="px-6 py-3 text-center">عنوان العميل</th>
              <th className="px-6 py-3 text-center">رقم هاتف العميل</th>
              <th className="px-6 py-3 text-center">إسم العميل</th>
            </tr>
          </thead>
          <tbody id="table_list_item">
            {orders.length !== 0 ? (
              orders.map((order) => {
                return <OrderRow key={order.orderId} order={order} />;
              })
            ) : (
              <tr>
                <th className="px-6 py-3 text-center"></th>
                <th className="px-6 py-3 text-center"></th>
                <th className="px-6 py-3 text-center"></th>
                <th className="px-6 py-3 text-center">-</th>
                <th className="px-6 py-3 text-center">-</th>
                <th className="px-6 py-3 text-center">-</th>
                <th className="px-6 py-3 text-center">-</th>
                <th className="px-6 py-3 text-center">-</th>
                <th className="px-6 py-3 text-center">-</th>
                <th className="px-6 py-3 text-center font-bold text-lg">لا يوجد طلبات حالياً</th>
              </tr>
            )}
            <td className="px-6 py-3  text-center"></td>
            <td className="px-6 py-3 text-center"></td>
            <td className="px-6 py-3 text-center"></td>
            <td className="px-6 py-3  font-bold text-center">{formatNumber(totalIraqiPrice)}</td>
            <td className="px-6 py-3  font-bold text-center">{formatNumber(totalCartons)}</td>
            <td className="px-6 py-3 text-center"></td>
            <td className="px-6 py-3 text-center"></td>
            <td className="px-6 py-3 text-center"></td>
            <td className="px-6 py-3 text-center"></td>
            <td className="px-6 py-3 text-center">مجموع</td>
          </tbody>
        </table>
      </div>
    </>
  );
};

export default OrderListTable;
